import h from "../services/h";

export default function(fullName) {
  return !fullName
    ? ""
    : h
        .collect((" " + (fullName || "")).match(/(\s)[a-zA-Z]/g), item =>
          item.trim()
        )
        .join("")
        .toUpperCase()
        .substring(0, 1);
}



// WEBPACK FOOTER //
// ./src/filters/buildShortNameFilter.js